// 消息中心
<template>
  <div>
    <van-nav-bar left-arrow :title="$t('menu.message')" @click-left="$router.go(-1)" left-arrow fixed placeholder />
    <van-tabs v-model="active" :line-width="187" :line-height="2" color="#999" @change="activeChange">
      <van-tab title="Notice"></van-tab>
      <van-tab title="Feedback"></van-tab>
    </van-tabs>
    <section class="messages">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="$t('tips.noMore')"
          :offset="100"
          @load="onLoad"
        >
          <div class="van-clearfix" v-if="list.length">
            <div class="card" v-for="item in list" :key="item.id">
              <div class="card-item flex justify-between align-center" @click="linkToDetail(item)">
                <div class="left">
                  <van-icon class="image" :class="item.point ? 'point' : ''" size="28" :name="require('@/assets/images/icon/notice.png')"></van-icon>
                </div>
                <div class="right flex-column">
                  <div class="title">{{item.title}}</div>
                  <div v-show="active === 0" class="content text-left" v-html="item.content"></div>
                  <div class="date">{{item.publishedTime}}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <van-empty :description="$t('message.noData')" />
          </div>
        </van-list>
      </van-pull-refresh>
    </section>
  </div>
</template>

<script>
import { getPromotionList, getReplyList } from '@/api'
export default {
  name: 'Message',
  data () {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      active: 0,
      pagination: {
        page: 1,
        size: 10,
        total: 1
      },
      list: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 初始化列表
    async init () {
      this.$toast.loading({
        duration: 0,
        forbidClick: true
      })
      if (this.active === 0) {
         await getPromotionList({
          pageNum: this.pagination.page,
          pageSize: this.pagination.size
        }).then(res => {
          this.loading = false
          this.list = [...this.list, ...res.data]
          this.pagination.page += 1
        }).finally(() => {
          this.$toast.clear()
        })
      } else {
        await getReplyList({
          pageNum: this.pagination.page,
          pageSize: this.pagination.size
        }).then(res => {
          this.loading = false
          this.list = [...this.list, ...res.data]
          this.pagination.page += 1
        }).finally(() => {
          this.$toast.clear()
        })
      }
    },
    // 底部加载
    onLoad () {
      this.loading = true
      if (this.list.length >= this.pagination.total) {
        this.finished = true
      } else {
        setTimeout(() => {
          this.init()
        }, 1000)
      }
    },
    // 下拉刷新
    onRefresh () {
      // 清空列表数据
      this.finished = false
      this.refreshing = true

      if (this.refreshing) {
        this.pagination.page = 1
        this.list = []
        this.refreshing = false
        this.loading = false
      }
      this.init()
    },
    linkToDetail (item) {
      var msgType = null;
      switch (this.active) {
        case 0: msgType = 'promotions'; break;
        case 1: msgType = 'ReplyForTheGiveBack'; break;
      }
      this.$router.push({
        name: 'messageDetail',
        query: {
          id: item.id,
          msgType: msgType,
        }
      })
    },
    activeChange (name, title) {
      console.log(name, title, this.active)
      this.pagination = {
        page: 1,
        size: 10,
        total: 1
      }
      this.list = []
      this.init()
    }
  }
}
</script>

<style lang="less">
  .messages {
    padding: 30px;
    .my-swipe {
      margin-bottom: 25px;
      .van-swipe-item {
        overflow: hidden;
        border-radius: 10px;
        img {
          width: 100%;
        }
      }
    }
    .card {
      width: 100%;
      box-sizing: border-box;
      border-radius: 10px;
      margin-bottom: 20px;
      .card-item {
        height: 100%;
        .left {
          margin-right: 24px;
          .image {
            border: 5px solid #000000;
            border-radius: 50%;
            padding: 24px;
          }
          .point {
            position: relative;
            &:after {
              content: '';
              position: absolute;
              right: 18px;
              top: 20px;
              width: 15px;
              height: 15px;
              border-radius: 50%;
              background: #E8252A;
            }
          }
        }
        .right {
          border-bottom: 1px solid #828282;
          padding: 20px 0;
          width: 100%;
          .title {
            padding: 0;
            color: #000;
            font-size: 22px;
            font-weight: bold;
          }
          .content {
            padding: 20px 0;
            color: #000;
            font-size: 17px;
            line-height: 1.2;
            p {
              width: 80%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .date {
            font-size: 17px;
            color: #828282;
          }
        }
      }
    }
  }
</style>
